import React, { useState } from 'react';
import { useFormik } from 'formik';
import {
	CHANGE_PASSWORD_FORM_FIELDS, CHANGE_PASSWORD_FORM_FIELDS_NAMES,
	ChangePasswordFieldsType, getChangePasswordDetailSchema, getResetPasswordDetailSchema,
	initialChangePasswordValues
} from '../../../constants/profile-settings/account-security/change-password-form';
import { BUTTON_TYPE, ButtonComponent } from '../../ButtonComponent';
import { useTranslation } from 'react-i18next';
import { ConfirmPasswordInput } from '../../comfirmPassword/ConfirmPasswordInput';
import { CHANGE_PASS_INPUTS } from '../../../constants/profile-settings/account-security/change-pass-inputs';
import { setNewPassword } from '../../../store/identyti/actions/security';
import { useIdentity } from '../../../store/identyti/identity-context';
import { resetPassword } from '../../../store/identyti/actions/users';

interface Props {
	closeModal: () => void;
	onSuccess: () => void;
	onError: () => void;
	userId?: string;
	userEmail?: string;
}

export const ChangePasswordForm = (props: Props): React.ReactElement => {
	const { closeModal, onSuccess, onError, userId, userEmail } = props;
	const { t } = useTranslation();
	const email = localStorage.getItem('userEmail');
	const [showPassword, setShowPassword] = useState(false);
	const [showConfirmPassword, setShowConfirmPassword] = useState(false);
	const [showCurrentPassword, setShowCurrentPassword] = useState(false);
	const { identityState: { isChangePasswordLoading }, dispatch } = useIdentity();

	const formik = useFormik<ChangePasswordFieldsType>({
		initialValues: initialChangePasswordValues,
		validationSchema: userId ? getResetPasswordDetailSchema(t) : getChangePasswordDetailSchema(t),
		onSubmit: async () => {
			if (userId) {
				await resetPassword(dispatch, formik, userId, onSuccess, onError);
			} else {
				await setNewPassword(dispatch, formik, email, onSuccess, onError);
			}
		}
	});

	const INPUTS = CHANGE_PASS_INPUTS({ showPassword, setShowPassword, showConfirmPassword, setShowConfirmPassword });

	return (
		<form onSubmit={formik.handleSubmit} className="px-20">
			<div className="row change-password-container">
				{
					!userId && (
						<ConfirmPasswordInput
							formik={formik}
							fieldName={CHANGE_PASSWORD_FORM_FIELDS.OLD_PASS}
							placeholder={t(CHANGE_PASSWORD_FORM_FIELDS_NAMES.OLD_PASS)}
							label={CHANGE_PASSWORD_FORM_FIELDS_NAMES.OLD_PASS}
							showPassword={showCurrentPassword}
							setShowPassword={setShowCurrentPassword}
							additionalClass="password-container position-relative col-12 pb-3"
							isPasswordShown={true}
							isSmallInput
							required
							autoComplete="current-password"
						/>
					)
				}
				{
					INPUTS.map(input => (
						<ConfirmPasswordInput
							{...input}
							key={input.key}
							formik={formik}
							required
							isSmallInput
						/>
					))
				}
			</div>
			<div className="text-center mt-15">
				<ButtonComponent
					buttonName="Cancel"
					buttonType={BUTTON_TYPE.CANCELLED}
					additionalClass="btn-sm"
					onButtonClick={closeModal}
				/>
				<ButtonComponent
					buttonName={userId ? 'Reset' : 'Change'}
					type="submit"
					additionalClass="btn-sm ms-10 w-100px"
					loading={isChangePasswordLoading}
				/>
			</div>
		</form>
	);
};
